module.exports = __webpack_public_path__ + "media/promo/courses/images/newbg-0efe9cd800488f25484e6da7774dd172.jpg";